import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import MainLayout from "../../themes/layouts/Main";
import Loader from "../../themes/components/Loader";
import { fetchSupplier } from "../../api/Supplier";
import SuppliersView from "../../components/Suppliers/View";

const SupplierViewRoute: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);

  const fetchData = async () => {
    const result = await fetchSupplier(id);
    setLoading(result.loading);
    setError(result.error);
    setData(result.data);
  };

  useEffect(() => {
    void fetchData();
  }, [id]);

  if (loading) return <Loader />;
  if (error || !data)
    return (
      <Alert severity="error">
        <AlertTitle>Error</AlertTitle>
        {error}
      </Alert>
    );

  return (
    <MainLayout>
      <SuppliersView supplier={data.supplier} refetch={fetchData} />
    </MainLayout>
  );
};

export default SupplierViewRoute;
